<template>
  <div class="container">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Customer</th>
          <th scope="col">Request Date</th>
          <th scope="col">Created Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="workorder.id" v-for="workorder in workorders" @click="viewWorkorder(workorder.id)">
          <th scope="row">{{workorder.id}}</th>
          <td>{{workorder.customerName}}</td>
          <td>{{moment(workorder.requestDate).format('MM/DD/YYYY')}}</td>
          <td>{{moment(workorder.createdOn).format('MM/DD/YYYY')}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  data(){
    return {
      moment,
      fullWorkorder: {},
    }
  },
  computed: {
    ...mapState(['workorders'])
  },
  methods: {
    viewWorkorder(id) {
      this.$router.push(`workorder/${id}`)
    }
  },
}
</script>